import { MainContentLayout } from 'shared/ui/layout';

import { EditCpo } from 'features/cpo/edit';

export function EditCpoPage() {
  return <MainContentLayout element={<EditCpo />} />;
}
